import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IDefeito,
  IGetDefeitosQueryParams
} from 'src/app/interfaces';

@Injectable({ providedIn: 'root' })
export class DefeitoService {
  private readonly baseURL = '/Defeito';
  constructor(private httpClient: HttpClient) {}

  getDefeitos(body: IGetDefeitosQueryParams = {}) {
    return this.httpClient.post<IApiResponse<IDefeito[]>>(this.baseURL, body);
  }
}
